import { Divider, useTheme } from "@mui/material"
import { faClone, faTrashCan } from "@fortawesome/pro-light-svg-icons"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardMenu } from "../menus/StandardMenu"
import { StandardMenuItem } from "../menus/StandardMenuItem"

type Props = Readonly<{
    anchorEl: HTMLElement | null
    onClose: () => void
    onDuplicate: () => void
    onDelete: () => void
}>

export function OrderKebabMenu({ anchorEl, onClose, onDuplicate, onDelete }: Props) {
    const theme = useTheme()

    const runAndClose = (action: () => void) => () => {
        action()
        onClose()
    }

    return (
        <StandardMenu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
            <StandardMenuItem icon={faClone} onClick={runAndClose(onDuplicate)}>
                <LocalizedStrict id="meeting-service-order-drawer-duplicate">
                    <span>Duplicate</span>
                </LocalizedStrict>
            </StandardMenuItem>
            <Divider />
            <StandardMenuItem icon={faTrashCan} textColor={theme.palette.error.main} onClick={runAndClose(onDelete)}>
                <LocalizedStrict id="meeting-service-production-view-card-delete-button">
                    <span>Delete</span>
                </LocalizedStrict>
            </StandardMenuItem>
        </StandardMenu>
    )
}
